import {getCompressedData} from '../../../_shared/GWTBridge/invoke/server';
import {getConnection} from '../../../_shared/GWTBridge/invoke/genPage';
import {buildServerCall} from '../../../services/wcfService';

export function saveSelectedCompanies(companiesJson) {
    const methodName = 'GeneralMultiCompaniesSet';
    const reason = 'GeneralMultiCompaniesSetAsync';
    const xml = getCompressedData(companiesJson, 'MultiCompanies');
    const parameters = {xml: [xml.compressed]};
    return buildServerCall(methodName, parameters, reason, false, getConnection);
}
